// import React, { useEffect } from "react";
import "../styles/Banner.scss";
// import AOS from 'aos';
// import 'aos/dist/aos.css';

const Banner = () => {
  //     useEffect(() => {
  //         AOS.init({duration: 2000});
  //         AOS.refresh();
  //     }, []);

  return (
    <div className="banner">
      <div className="texts">
        <div className="text-bottom">
          <h2>
            Tattoo Studio Rakac
            <span>Tattoo Studio Rakac</span>
            <span>Tattoo Studio Rakac</span>
            <span>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s.
            </span>
          </h2>
        </div>
      </div>
    </div>
  );
};

export default Banner;

/* <ul className="Words" id="Words">
  <li className="Words-line">
    <p className="Words-p">&nbsp;</p>
    <p className="Words-p">Tattoo</p>
  </li>
  <li className="Words-line">
    <p className="Words-p">Dizajn</p>
    <p className="Words-p">Studio Rakac</p>
  </li>
  <li className="Words-line">
    <p className="Words-p">Kreativnost</p>
    <p className="Words-p">Sa vama</p>
  </li>
  <li className="Words-line">
    <p className="Words-p">Umetnost</p>
    <p className="Words-p">od</p>
  </li>
  <li className="Words-line">
  <p className="Words-p">Sloboda</p>
  <p className="Words-p">2024</p>
  </li>
  <li className="Words-line">
  <p className="Words-p">Izražavanje</p>
  <p className="Words-p">Godine</p>
  </li>
  <li className="Words-line">
  <p className="Words-p">Hrabrost</p>
  <p className="Words-p">&nbsp;</p>
  </li>
</ul> */
